import { useMemo } from "react";
import { useGetUsersQuery } from "features/api/permissionsApi.ts";
import { useGetUserDetailsQuery } from "features/api/userApi.ts";
import { UserPermission } from "types/declarations/enums.ts";
import { AssignedToPersonNameLookup, getAssignedToPersonLookupKey } from "../utils/LeadAssignmentsPage.utils.ts";

const getPersonDisplayName = (person: {
	firstName?: string | null;
	lastName?: string | null;
	email?: string | null;
	userId?: string | null;
}) => [person.firstName, person.lastName].filter(Boolean).join(" ") || person.email || person.userId || "";

export const useAssignedToPersonNameLookup = () => {
	const { data: userDetails } = useGetUserDetailsQuery();
	const isAdmin = userDetails?.permissions?.includes(UserPermission.ADMIN) ?? false;
	const { data: people } = useGetUsersQuery(undefined, { skip: !isAdmin });

	return useMemo(() => {
		const assignedToPersonNameLookup: AssignedToPersonNameLookup = {};
		const currentUserLookupKey = getAssignedToPersonLookupKey(userDetails?.userId);
		const currentUserName = userDetails ? getPersonDisplayName(userDetails) : "";

		if (currentUserLookupKey && currentUserName) {
			assignedToPersonNameLookup[currentUserLookupKey] = currentUserName;
		}

		for (const person of people ?? []) {
			const personLookupKey = getAssignedToPersonLookupKey(person.userId);
			const personName = getPersonDisplayName(person);

			if (personLookupKey && personName) {
				assignedToPersonNameLookup[personLookupKey] = personName;
			}
		}

		return assignedToPersonNameLookup;
	}, [people, userDetails]);
};
